import { ReactNode } from "react"

interface SmallestHeadingComponentProps {
    children: ReactNode
    onClick?: () => void
}

function SmallestHeadingComponent(props: SmallestHeadingComponentProps) {
    return (
        <div
            onClick={() => {
                if (props.onClick) {
                    props.onClick()
                }
            }}
            className={
                "text-2xl font-bold " +
                (props.onClick ? "cursor-pointer hover:underline" : "")
            }>
            {props.children}
        </div>
    )
}

export default SmallestHeadingComponent
